import SearchFormCDR from "./SearchFormCDR";
import { useDispatch, useSelector } from "react-redux";
import format from "date-fns/format";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import { useState } from "react";
import Loader from "../../../loader";
import { Typography } from "@mui/material";
import customToolbar from "../../../customToolbar";
import CDRTable from "../CDRTable";
import ExportButton from "../exportButton";
import downloadCDRCSV from "../downloadCDRCSV";
import constants from "../../../../constants";
import useFormData from "../../../../useFormData";
import {useNavigate} from "react-router-dom";
import {useSnackbar} from "notistack";
import Button from '@mui/material/Button';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Stack } from '@mui/material';

export const HistoricalCDR = () => {

    let [data, setData] = useState(null);
    let [err, setError] = useState(null);
    let [form, setForm] = useState(null);
    let [nodata, setNodata] = useState(false);

    let config = useSelector(state => state.session.config);
    let dispatch = useDispatch();
    let [showLoader, setShowLoader] = useState(false);
    let [total, setTotal] = useState(0);

    let navigate = useNavigate();

    const [paginationModel, setPaginationModel] = useState({
        pageSize: 25,
        page: 0,
    });

    let getFormData = useFormData();


    const { enqueueSnackbar } = useSnackbar();

    //PageLimit_HistoricMissedCallCDR
    async function getData(form, newModel) {
        setShowLoader(true);

        let s = format(form.startDate, 'dd-MM-yyyy');
        s += 'T00:00:00';
        let e = format(form.endDate, 'dd-MM-yyyy');
        e += 'T23:59:59';

        let offset = newModel.page * newModel.pageSize;

        let formData = getFormData();
        formData.append("action", "PageLimit_HistoricMissedCallCDR");
        formData.append("startDate", s);
        formData.append("endDate", e);
        formData.append("offset", offset);
        formData.append("limit", newModel.pageSize);

        let url = `${config.reportsURL}`;

        try {
            const response = await axios.post(url, formData, {
                timeout: config.apiTimeOut,
                headers: {
                    apiKey: constants.k
                }
            });
            if (response.status === 200 && response.data) {
                if (response.data.status === "SUCCESS") {
                    if (Array.isArray(response.data.data) && response.data.data.length > 0) {
                        setData(response.data.data);
                        setForm(form);
                        setPaginationModel(newModel);
                        if (offset === 0) { //only for first req
                            setTotal(response.data.total || 0);
                        }
                        setNodata(false);
                    } else {
                        setNodata(true);
                    }
                }
            }
            setShowLoader(false);
        } catch (err) {
            setShowLoader(false);
            setNodata(true);
        }
    }

    function handleSubmit(form) {
        setData(null);
        getData(form, {
            pageSize: 25,
            page: 0,
        });
    }

    function onPaginationModelChange(newModel) {
        getData(form, newModel)
    }

    async function getDataForExport(form) {
        setShowLoader(true);

        let s = format(form.startDate, 'dd-MM-yyyy');
        s += 'T00:00:00';
        let e = format(form.endDate, 'dd-MM-yyyy');
        e += 'T23:59:59';

        let url = `${config.reportsURL}`

        let formData = getFormData();
        formData.append("action", "HistoricMissedCallCDR");
        formData.append("startDate", s);
        formData.append("endDate", e);

        try {
            const response = await axios.post(url, formData, {
                timeout: config.exportTimeOut,
                headers: {
                    apiKey: constants.k
                }
            });
            if (response.status === 200 && response.data) {
                if (response.data.status === "SUCCESS") {
                    if (Array.isArray(response.data.data) && response.data.data.length > 0) {
                        downloadCDRCSV(response.data.data, "Historical_CDR");
                    }
                }
            }
            setShowLoader(false);
        } catch (err) {
            setShowLoader(false);
        }
    }

    async function requestToDownload(startDate, endDate) {
        setShowLoader(true);

        let formData = getFormData();
        formData.append("action", "requestToDownload");
        formData.append("startDate", startDate);
        formData.append("endDate", endDate);


        let url = `${config.requestToDownloadURL}`

        try {
            const response = await axios.post(url, formData, {
                timeout: config.exportTimeOut,
                headers: {
                    apiKey: constants.k
                }
            });
            if (response.status === 200 && response.data) {
                if (response.data.status === "SUCCESS") {
                    // navigate('/downloadReports');
                    enqueueSnackbar(response.data.message, {
                        variant: 'success',
                        anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'right',
                        }
                    })
                }

                if (response.data.status === "FAILURE") {
                    enqueueSnackbar(response.data.message, {
                        variant: 'error',
                        anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'right',
                        }
                    })
                }
            }
            setShowLoader(false);
        } catch (err) {
            setShowLoader(false);
        }
    }

    function handleExportClick(form) {
        getDataForExport(form);
        let s = format(form.startDate, 'yyyy-MM-dd');
        // s += 'T00:00:00';
        let e = format(form.endDate, 'yyyy-MM-dd');
        // e += 'T23:59:59';
        //requestToDownload(s, e);
    }

    return (<>
        <Typography variant="body1">Historical CDR</Typography>
        <SearchFormCDR submitCallback={handleSubmit} exportCallback={handleExportClick}  />
        <div style={{ marginTop: '5px' }}>
            <ShowTable data={data}
                form={form}
                onPaginationModelChange={onPaginationModelChange}
                model={paginationModel}
                exportClick={handleExportClick}
                total={total}
                getDataForExport = {getDataForExport} />
        </div>
        <Loader showLoader={showLoader} />
        {
            nodata ?
                <div style={{ textAlign: 'center' }}>No Data Found!</div> : null
        }
    </>)
}

function ShowTable({ data, form, onPaginationModelChange, exportClick, total, model,getDataForExport }) {
    //alert(total);
    if (!form || !data) {
        return <></>;
    }

    // return <Table1 data={data} form={form}/>

    function exportButtonClick() {

        if (exportClick) {
            exportClick();
        }
    }

    function handlePMC(model) {
        onPaginationModelChange(model)
    }
    const handleExportClick2 = (form) => {
        console.log("form Data",form);
        getDataForExport(form);
    }

    return<>
    <Stack alignItems='flex-end'>
            <Button variant="text"  onClick={() => handleExportClick2(form)}><FileDownloadIcon fontSize='small'/> Export</Button>
        </Stack>
        <CDRTable data={data} onPaginationModelChange={handlePMC}
        total={total}
        model={model}
        form ={form} />
    </> 
    
}

function Table1({ data, form }) {

    let rows = data;

    let columns = [
        { field: 'Country', headerName: 'Countrsssy', sortable: false },
        { field: 'MobileNo', headerName: 'MobileNo', sortable: false },
        { field: 'VMN', headerName: 'VMN', sortable: false },
        { field: 'Trans_id', headerName: 'Transaction ID', width: 250, sortable: false },
        { field: 'DID', headerName: 'DID', width: 250, sortable: false },
        { field: 'MissedCall_Date', headerName: 'MissedCall Date', width: 250, sortable: false },
        { field: 'MissedCall_Time', headerName: 'MissedCall Time', width: 250, sortable: false },
        { field: 'Contestant_name', headerName: 'Contestant Name', width: 250, sortable: false },
        { field: 'status', headerName: 'Status', sortable: false },
    ]

    let CustomToolbar = customToolbar("Historical_CDR");

    return (<>
        <div style={{ marginTop: '5px', marginBottom: '5px' }}>
            {/*Showing Historical Missed Call CDR from <b>{format(form.startDate, 'PP')}</b> to <b>{format(form.endDate, 'PP')}</b>*/}
        </div>
        <DataGrid rows={rows} columns={columns} getRowId={(r) => r.Trans_id} slots={{
            toolbar: CustomToolbar,
        }} />
    </>)
}
